<template>
  <div id="sig-container" class="block full form-horizontal">
    <form @submit.prevent="updatePassword">
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <div class="widget">
        <div class="widget-content widget-content-mini themed-background-dark-default text-light">
          <span class="float-right text-muted">
            <button type="button" @click="$router.go(-1)" class="btn btn-xs btn-primary">Volver</button>
          </span>
          Cambiar contraseña
        </div>
        <div class="widget-content border-bottom themed-background-muted text-center">
          <div class="container">

            <div class="row mt-2">
              <label for class="col-3 control-label text-right">
                <strong>Contraseña</strong>
              </label>
              <div class="col-9">
                <input
                  type="password"
                  v-model="credentials.password"
                  id="password"
                  class="form-control"
                  placeholder="Contraseña"
                />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{'has-error': errors?errors['password']:false}">
              <div class="col-9 offset-3">
                <span
                  class="help-block"
                  v-if="errors?errors['password']:false"
                >{{ errors?errors['password'][0]:'' }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for class="col-3 control-label text-right">
                <strong>Confirmar Contraseña</strong>
              </label>
              <div class="col-9">
                <input
                  type="password"
                  v-model="credentials.password_confirm"
                  id="password_confirm"
                  class="form-control"
                  placeholder="Confirmar Contraseña"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-6 offset-md-3 text-center mt-3">
                <button class="btn btn-sm btn-info">{{ 'Cambiar contraseña' }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "change-password",
  data: () => {
    return {
      credentials: {},
      errors: null
    };
  },
  computed: {
    ...mapGetters({ usuarios: "user/usuarios", loading: "loading" })
  },
  components: {
    //
  },
  methods: {
    updatePassword() {
      if (this.credentials.password) {
        if (this.credentials.password == this.credentials.password_confirm) {
          this.$store
            .dispatch("store", {
              endpoint: "usuario/update-password",
              params: {
                id: "take",
                new_password: this.credentials.password,
                password_confirm: this.credentials.password_confirm
              }
            })
            .then(response => {
              this.$notify({
                title: "Usuario",
                type: "success",
                content: "La acción se completó con éxito"
              });
            })
            .catch(error => {
              this.errors = error.data.errors;
              this.$notify({
                title: "Usuario",
                type: "warning",
                content: "Los datos dados no son válidos"
              });
            });
        } else {
          this.$notify({
            title: "Usuario",
            type: "warning",
            content: "Las contraseñas no coinciden"
          });
        }
      }
    }
  },
  mounted() {
    //
  }
};
</script>